module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "chap01"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("SOME LIBERAL PERSPECTIVES")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Jesus, Science, Abortion, and Same-Sex Marriage")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("All who are led by the Spirit of God are children of God.")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("—Romans 8:14")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Do not put the Lord your God to the test.")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("—Matthew 4:7")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("For everything there is a season … a time to be born.")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("—Ecclesiastes 3:1–2")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Love is patient; love is kind … It does not insist on its own way.")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', [_vm._v("—I Corinthians 13:4–5")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("A PERSPECTIVE ON JESUS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("A")]), _vm._v(" Hindu priest with whom I spent a college-era summer in India used to speak of avatars: people with clear mystical awareness who have direct knowledge of the infinite spirit that infuses the universe. In other words, they have true God-consciousness. Avatars, he said, help the rest of us see what God is like in human form. They are sons or daughters of God in a uniquely pure way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The priest's avatar was Ramakrishna, a nineteenth-century saint who inspired an order and mission in India that has come to be known in America as the Vedanta Society. At the end of the summer, when I expressed a strong interest in becoming a Hindu, the Hindu priest said no. Ramakrishna, he said, taught that avatars have had different impacts from culture to culture and era to era. Yet, ultimately—although they use different names and different religious methodologies—they all point to the "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("same God. So Ramakrishna advised seekers not to look outside their own tradition, but to follow the path they know best with wholehearted devotion. Ramakrishna counseled, “A Christian should follow Christianity, a Muslim should follow Islam, and so on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The priest directed me back to the Christianity with which I had grown up. He insisted that Jesus was my avatar, not Ramakrishna nor the Buddha nor anyone else. It was in Jesus's footsteps that I should walk to know God better. That didn't mean I should bring along all my prior assumptions about Jesus being the only way to God for all people. I needed to develop a wider view of Christianity that included respect not only for other religions but also for everything I'd come to know scientifically, logically, and rationally.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I returned to the United States, I discovered and joined the Unitarian Universalist denomination. Rooted in liberal Christianity, it is wide open to the religions of the world as well as to those who do not accept the label “religious.” In seminary, I learned about the sermon that Unitarian minister Ralph Waldo Emerson preached in 1838 to the graduates of the Harvard Divinity School. Jesus's role as avatar came through loud and clear in that magnificent address:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Jesus Christ belonged to the true race of prophets. He saw with open eye the mystery of the soul. Drawn by its severe harmony, ravished with its beauty, he lived in it, and had his being there … He saw that God incarnates himself in man … He said, in this jubilee of sublime emotion, “I am divine. Through me, God acts; through me, speaks. Would you see God, see me; or, see thee, when thou thinkest as I now think.”"), _c('a', {
    attrs: {
      "id": "inote-19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That's how I'm drawn to be a follower of Jesus in the liberal Christian tradition. I'm also struck by how Jesus of Nazareth, more than two thousand years after his birth, continues to astonish and inspire so many people. His teachings are dramatic and surprising and challenging. He insists that we love our enemies, not just our friends, and that we pray for those who persecute us, forgiving their trespasses. He uncomfortably confronts us with our own hypocrisy: “First take the log out of your own eye, and then you will see clearly to take the speck out of your neighbor's eye.” He also provides comforting assurance that we can let go of our material insecurities: “Do not worry about your life, what you will eat or what you "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("will drink, or about your body, what you will wear … Look at the birds of the air; they neither sow nor reap…[and] the lilies of the field, how they grow; they neither toil nor spin.” These lessons are but a fraction of what he taught in one sermon—the “Sermon on the Mount,”"), _c('a', {
    attrs: {
      "id": "inote-20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" which Gandhi called us to drink deeply of and Martin Luther King Jr. credited as foundational to the modern American civil rights movement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Genuine transformation is possible by trying to live in his ways. We can follow Jesus individually, with our studies, meditations, and private prayers, and by living according to his teachings. We can also follow Jesus by becoming part of the Body of Christ, a community of believers gathered together in church. But what do we really know about Jesus?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First of all, we can fairly say that he was a real historical figure. The facts concerning his life and work are so abundant that even atheist Richard Dawkins in his book "), _c('em', [_vm._v("The God Delusion")]), _vm._v(" concedes that Jesus “probably” did exist."), _c('a', {
    attrs: {
      "id": "inote-21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" Today, most people's understanding of Jesus is drawn not from the various contemporaneous Roman, Jewish, and pagan sources, but from the collection of writings that we now know as the New Testament. Current scholarship views most of the books of the New Testament as having been written between 50 and 100 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D")]), _vm._v("., starting a generation after the death of Jesus, around 30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D")]), _vm._v(". The earliest materials are the letters of Paul, written in the 50s, while the Gospel of John may have been as late as 100 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "inote-22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Modern biblical scholars have used a variety of tools to try to generate solid data about the Jesus of history. For example, conservative N. T. Wright explains that “the scientific method of hypothesis and verification” is central to this work."), _c('a', {
    attrs: {
      "id": "inote-23"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" Liberal John Dominic Crossan describes three critical sources for locating the historical Jesus: literary and textual analysis of the New Testament and other Christian documents, use of non-Christian texts to understand the Greco-Roman and Jewish context of the time, and cross-cultural anthropology."), _c('a', {
    attrs: {
      "id": "inote-24"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" Liberal Marcus Borg also refers to the role of archaeology in this enterprise."), _c('a', {
    attrs: {
      "id": "inote-25"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to a number of scholars, we can feel confident now about making the following six claims for the historical Jesus:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("1. Jesus was a first-century Palestinian Jew.")]), _vm._v(" He acted and taught within Judaism in a particular eastern Mediterranean outpost of the Roman Empire."), _c('a', {
    attrs: {
      "id": "inote-26"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" Jews were convinced that their god was the one true god, and "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("that the gods of other nations and cultures were mere human creations or idols. Jews also believed they were elect among all the nations as the chosen people of this one and only god."), _c('a', {
    attrs: {
      "id": "inote-27"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Jesus was certainly involved in critiquing his own tradition, but his criticism was always from the inside. Rather than calling for his people to abandon Judaism for a new and different religion, he was asking them to become the true people of the one true God. Jesus wanted Israel reconstituted—nothing more and nothing less."), _c('a', {
    attrs: {
      "id": "inote-28"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("2. Jesus was a prophet of Israel.")]), _vm._v(" I don't mean the type of prophet who primarily foretold the future, but one who called the Jewish people (and sometimes other nations) to account, speaking on behalf of God."), _c('a', {
    attrs: {
      "id": "inote-29"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" Jesus referred to himself as a prophet, acted like a prophet, and didn't correct other people when they referred to him as a prophet."), _c('a', {
    attrs: {
      "id": "inote-30"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" Early in his public career, he seems to have been in the circle of another prophet, John the Baptist."), _c('a', {
    attrs: {
      "id": "inote-31"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("3. Jesus announced the coming of the kingdom of God.")]), _vm._v(" John baptized Jesus when he was about thirty,"), _c('a', {
    attrs: {
      "id": "inote-32"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" and his public ministry lasted only a few years at the most before the Romans executed him. During this time his primary mission appears to have been announcing that the “kingdom of God” was breaking into the world, like light coming through a crack in the wall of a dark room, and eventually would achieve the total transformation of all that was known. This wasn't a matter of military rebellion against the Romans, as many Jews of the time were hoping. Instead, Jesus seemed to mean that God's rule was coming to replace that of all political authorities."), _c('a', {
    attrs: {
      "id": "inote-33"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In order to begin living in relation to the emerging, in-breaking kingdom of God, Jesus called for a radical equality. Class, rank, and gender were to be commingled. Eating together was central to Jesus's mode of operation, and he invited everyone to the same table—women and men, slaves and free people, socially privileged and socially excluded, ritually pure and ritually impure."), _c('a', {
    attrs: {
      "id": "inote-34"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" A world with God totally in charge, rather than a Caesar or a Herod, requires social justice. The poor become rich and the hungry are fed."), _c('a', {
    attrs: {
      "id": "inote-35"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("4. Jesus was a political radical.")]), _vm._v(" He came from the marginalized peasant class in a marginalized village in Galilee, a region north of Jerusalem that was undergoing rapid social change at the time. His hometown of Nazareth was just a few miles from the largest city of Galilee, "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Sepphoris, which was also the political center for King Herod. So Jesus could easily compare huge differences in wealth and culture within Judaism. His preaching and actions demonstrated an unusual sensitivity to the poor and the oppressed."), _c('a', {
    attrs: {
      "id": "inote-36"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Jesus arrived in Jerusalem at the time of the Passover, near the end of his life, he went to the temple and violently disrupted its fiscal, sacrificial, and liturgical operations,"), _c('a', {
    attrs: {
      "id": "inote-37"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-37",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" as reported in all four gospels."), _c('a', {
    attrs: {
      "id": "inote-38"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" He threw over the tables of the moneychangers and ran them out of the temple. He also threw over the seats of people selling animals to be sacrificed. The account in John 2:15 has him using a whip to drive out not only the moneychangers and sellers, but also large sacrificial animals like sheep and oxen. This was likely the immediate reason for his arrest and execution, since neither Jewish nor Roman authorities could tolerate this kind of dramatic disorder at the very center of the capital's life during this busy holiday season."), _c('a', {
    attrs: {
      "id": "inote-39"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-39",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("5. Jesus was a healer.")]), _vm._v(" This activity also had political and social implications. He ministered to those who were rejected by society—the lepers, the insane, and the disabled—and gave them back some degree of control over their own lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Dominic Crossan claims that Jesus didn't actually cure illnesses like leprosy or correct physical conditions like lameness. Instead, Jesus healed in the sense of removing the personal and social stigmas of uncleanliness, isolation, and rejection associated with these conditions. He opened his arms and brought the sick and the handicapped back into the community from which they'd been excluded, making the world humanly habitable and hospitable again for them. This didn't endear him to those in authority, but it made him very popular among the dispossessed."), _c('a', {
    attrs: {
      "id": "inote-40"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-40",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Jesus, living in expectation of the coming kingdom of God was a matter of action and a way of life, not just a matter of words. Marcus Borg points out that Jesus explicitly connected healing with the coming kingdom of God as a time of deliverance."), _c('a', {
    attrs: {
      "id": "inote-41"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-41",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" N. T. Wright reminds us that this activity was a major part of Jesus's public work and that it included the healing of societies and institutions, along with psychological healing, healing of memories, and a wide range of other phenomena."), _c('a', {
    attrs: {
      "id": "inote-42"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-42",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("6. Jesus was a wisdom teacher.")]), _vm._v(" As he described how to live in relation to the incipient kingdom of God, Jesus's teachings became a kind of "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("wisdom, and they felt subversive and challenging, rather than conventional."), _c('a', {
    attrs: {
      "id": "inote-43"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-43",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" He used aphorisms and parables to prod others to see the world in a radically new way. The kingdom of God demanded a new social and ethical vision, with compassion and love at its core:"), _c('a', {
    attrs: {
      "id": "inote-44"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-44",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" “Blessed are you who are poor, for yours is the kingdom of God.” “Be merciful, just as your Father is merciful.” “Do not judge, and you will not be judged.”"), _c('a', {
    attrs: {
      "id": "inote-45"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-45",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, this is all well and good. But the critical question for many people is this: “Was Jesus the Son of God?” For liberal Christians, the question of whether we can call Jesus the Son of God can't be answered with a simple yes or no. Jesus himself never uses the term “Son of God” to describe himself in the first three gospels."), _c('a', {
    attrs: {
      "id": "inote-46"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-46",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" He does speak of others being sons or daughters of God: “Blessed are the peacemakers, for they shall be called children of God” (Matthew 5:9). This was common phraseology in his day, as when the apostle Paul says, “All who are led by the Spirit of God are children of God.”"), _c('a', {
    attrs: {
      "id": "inote-47"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" Scholars generally agree that the exclusive use of the title “Son of God” would have been incomprehensible to Palestinian Jews of Jesus's time, although not to those who later taught or learned about the post-Easter Jesus in the non-Jewish, Hellenistic world outside of Palestine."), _c('a', {
    attrs: {
      "id": "inote-48"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-48",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Part of the answer might be found in making a seventh claim about Jesus. He can fairly be called a mystic. It's entirely appropriate for us to refer to the historical Jesus by the term “spirit person.”"), _c('a', {
    attrs: {
      "id": "inote-49"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-49",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" Jesus is reported in Luke 4:18 to have said, quoting Isaiah, in his first moment of public ministry: “The Spirit of the Lord is upon me.”"), _c('a', {
    attrs: {
      "id": "inote-50"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-50",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" Like the prophets of Israel before him, Jesus had intense mystical experiences in which he felt totally in the presence of what he would call God. These were ecstatic moments—nonordinary states of consciousness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For example, when John baptized him, Jesus had a vision of the heavens opening up and “the Spirit descending like a dove on him.”"), _c('a', {
    attrs: {
      "id": "inote-51"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-51",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" Jesus also had a number of visions during the following forty days that he spent alone out in the desert on what a modern anthropologist would call a vision quest or wilderness ordeal, which is typical for mystics."), _c('a', {
    attrs: {
      "id": "inote-52"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-52",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" It is also clear that Jesus regularly engaged in spiritual exercises common for mystics, like fasting and long periods of extended prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His mysticism helps to explain Jesus's power for others as a wisdom teacher, healer, and announcer of the kingdom of God. Mystics have "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("historically found themselves in trouble with mainstream members of their own religious tradition and with political authorities, especially when they took actions that radically challenged the status quo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Jesus during his lifetime on earth would never have recognized certain titles later applied to him—“coequal with God,” “of one substance with God,” “the second person of the Trinity”—the early church began developing these ideas about him soon after his death. There's no doubt that his followers after his death moved from considering him a spirit person or mystic to increasingly speaking of him as having qualities of God and then as being divine himself."), _c('a', {
    attrs: {
      "id": "inote-53"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-53",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet, many liberal Christians like me see Jesus as the Son of God only in the sense described by the apostle Paul in Romans 8:14: “All who are led by the Spirit of God are children of God.” Jesus was surely led by the Spirit of God in a very special way—as a true avatar in the words of the Hindu priest, and as a mystic who also had extraordinary abilities as prophet, healer, and wisdom teacher. Yet, personally, I don't believe that Jesus was or is identical with God, nor do I think that's what he believed either, based on the biblical evidence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But that has no impact on my decision joyfully to choose to try to walk in his footsteps. In fact, in makes him more accessible to me as a fellow human being to whom I can relate. He is as Spirit-filled as I can imagine, and I proudly call him my “lord and savior”—in the sense of being my spiritual master and bringing ultimate meaning and purpose into my life. As Emerson said, “He saw with open eye the mystery of the soul.” We can too, if we follow him.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("CHRISTIANITY CAN BE RATIONAL AND SCIENTIFIC")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are a number of hot-button issues that separate liberal and conservative Christians, including views on evolution, abortion, and marriage for same-sex couples. I'll take on these three directly in this first chapter in order to clear the air, or at least to put my cards on the table, in these controversial areas. Then, I believe I'll be freer to look at essential dimensions of Christianity from a liberal perspective, including love, God, Jesus, the church, the Bible, and faith.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("So, what do we do with the biblical claim in Genesis that the universe as we know it—including the earth with vegetation, living creatures of every kind, and human beings—was all created in six days?"), _c('a', {
    attrs: {
      "id": "inote-54"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-54",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" How does Christianity square with modern science? What would really have happened if Jesus had thrown himself off the temple, when he was tempted by the devil to defy the law of gravity early in his ministry? He wisely responded, “Do not put the Lord your God to the test.”"), _c('a', {
    attrs: {
      "id": "inote-55"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-55",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Questions about the relationship of religion and science were at a high pitch in 2008 at Stanford. We were treated to lectures on this subject by journalist Christopher Hitchens and scientists Richard Dawkins and Francis Collins. Hitchens is the author of a best seller entitled "), _c('em', [_vm._v("God Is Not Great: How Religion Poisons Everything.")]), _vm._v(" In the first chapter of that book he states one of his irreducible objections to religious faith: “It wholly misrepresents the origins of man and the cosmos.”"), _c('a', {
    attrs: {
      "id": "inote-56"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-56",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" He explains that he “distrust[s] anything that contradicts science or outrages reason.”"), _c('a', {
    attrs: {
      "id": "inote-57"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-57",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" One of the major problems for religion is that it “comes from the period of human prehistory where nobody … had the smallest idea of what was going on. It comes from the bawling and fearful infancy of our species, and is a babyish attempt to meet our inescapable need for knowledge … Today the least educated of my children knows much more about the natural order than any of the founders of religion … All attempts to reconcile faith with science and reason are consigned to failure and ridicule for precisely these reasons.”"), _c('a', {
    attrs: {
      "id": "inote-58"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-58",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By contrast, the late Rev. Jerry Falwell, founder of Liberty University in Lynchburg, Virginia—a university that now has more than 20,000 students"), _c('a', {
    attrs: {
      "id": "inote-59"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-59",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v("—wrote that “The Bible is the inerrant … word of the living God. It is absolutely infallible, without error in all matters pertaining to faith and practice, as well as in areas such as geography, science, history, etc.”"), _c('a', {
    attrs: {
      "id": "inote-60"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-60",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" In 2007 the "), _c('em', [_vm._v("New York Times")]), _vm._v(" published an article about a professor of earth sciences at Liberty University, Marcus Ross, who received his Ph.D. in geosciences from the University of Rhode Island. He believes that the Bible presents a literally true account of the creation of the universe and that the earth is at most 10,000 years old."), _c('a', {
    attrs: {
      "id": "inote-61"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-61",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each year at the Stanford Memorial Church we celebrate Evolution Sunday. We're part of a growing national movement of more than 500 congregations across the country and around the world committed to affirming that timeless religious truths and the discoveries of modern science can comfortably coexist. I am among more than 10,000 Christian clergy who have "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("signed an open letter that states, in part, that the majority of Christians don't read the Bible literally, as they would a science textbook, and that many of the beloved stories found in the Bible, such as the Genesis account of creation, convey truths of a different order than scientific truth. They touch hearts, as is the province of great literature, poetry, and art, but they are not intended to convey scientific information. Here's where I feel both Hitchens and Falwell are wrong. As we state in that open letter:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("We believe that the theory of evolution is a foundational scientific truth, one that has stood up to rigorous scrutiny and upon which much of human knowledge and achievement rests. To reject this truth or to treat it as “one theory among others” is to deliberately embrace scientific ignorance and transmit such ignorance to our children. We believe that among God's good gifts are human minds capable of critical thought … We ask that science remain science and that religion remain religion, two very different, but complementary, forms of truth."), _c('a', {
    attrs: {
      "id": "inote-62"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-62",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 2008 at Stanford we also had physician-geneticist Francis Collins, director of the National Human Genome Research Institute, on campus. He directs the multinational 2,400-scientist team that mapped the three billion letters of the human DNA blueprint. He's also a devout Christian who converted from atheism at the age of 27 and now advises evangelical scientists on how to reconcile their faith with their scientific careers."), _c('a', {
    attrs: {
      "id": "inote-63"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-63",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" He's a best-selling author himself, having written "), _c('em', [_vm._v("The Language of God")]), _vm._v(" (2006).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his Stanford talk “God and the Genome” to an overflow audience in our largest auditorium, Collins asserted that science and religion tend to address different questions: how versus why. Science discovers natural laws that tell us how the universe operates. Religion asks big existential questions like, “Why is there something instead of nothing?” But there are also ways in which religion and science overlap, of necessity. Collins says that his faith must rest squarely upon what he knows through logic and reason and science. Skepticism and doubt, of the sort encouraged by the scientific method, are critical to the development and testing of faith. Evolution is a scientific theory like gravity, which has been proven beyond a shadow of a doubt. Biblical literalism is a major problem when it leads to results such as seeing the universe as we now know it as having been created in six days, or human beings as having been created just as we are now, out of the blue, "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("rather than having evolved from other living organisms that first appeared on the earth billions of years ago. Our own species, homo sapiens, evolved from primate ancestors about 200,000 years ago."), _c('a', {
    attrs: {
      "id": "inote-64"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-64",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Collins calls himself a theistic evolutionist. For him, DNA is the way God spoke life into being, and evolution is the mechanism by which God's plan has been carried out. One might ask, though, why do you need God at all? Why aren't the scientific answers alone enough? Darwin himself, at the close of his revolutionary book "), _c('em', [_vm._v("On the Origin of Species,")]), _vm._v(" wrote of the Creator behind the natural laws of the universe:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("To my mind it accords better with what we know of the laws impressed on matter by the Creator, that … [we] view all beings not as special creations, but as the lineal descendants of some few beings which lived long before the first bed of the Silurian system was deposited…It is interesting to contemplate an entangled bank, clothed with many plants of many kinds, with birds singing on the bushes, with various insects flitting about, and with worms crawling through the damp earth, and to reflect that these elaborately constructed forms, so different from each other, and dependent on each other in so complex a manner, have all been produced by laws acting around us … There is grandeur in this view of life … having been originally breathed into a few forms or into one; and that, whilst this planet has gone cycling on according to the fixed law of gravity, from so simple a beginning, endless forms most beautiful and most wonderful have been, and are being, evolved."), _c('a', {
    attrs: {
      "id": "inote-65"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-65",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There's another way that Francis Collins references God. He talks about the improbability of life, and especially of human life, as having occurred just by chance. Several scientific constants were necessary. Gravitation was one of them, and if it had been off by just “one part in a hundred million million, then the expansion of the universe after the Big Bang would not have occurred in the fashion that was necessary for life to occur.” A designer becomes “a rather plausible explanation for what is otherwise an exceedingly improbable event—namely, our existence.” Collins recognizes that other scientific theories have been proposed, such as our universe being only one of a very large number of parallel universes, which increases the odds that a tiny minority of universes, like ours, will have just the right fine-tuning to support life somewhere "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("within them. But Collins finds the explanation of a creator God to be more compelling in its simplicity and elegance than “the bubbling of all these multiverses.”"), _c('a', {
    attrs: {
      "id": "inote-66"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-66",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, he disagrees with the modern proponents of so-called Intelligent Design, a theory that many claim was first propounded by a University of California–Berkeley law professor, Phillip Johnson, in 1991."), _c('a', {
    attrs: {
      "id": "inote-67"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-67",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" Advocates of Intelligent Design challenge the theory of evolution by claiming that there are cases of irreducible complexity, like the human eye or the blood-clotting mechanism, which could not have occurred stepwise through the long process of evolutionary natural selection. Instead, an intelligent designer must have stepped in and created these particular organs and functions, full-blown in all of their complexity, in one fell swoop. Collins retorts that these arguments have no scientific merit, and each of the claims that particular mechanisms could not have evolved through step-by-step natural selection have since been refuted."), _c('a', {
    attrs: {
      "id": "inote-68"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-68",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" There are also important theological objections to Intelligent Design theory since it reduces God to certain gaps in current scientific explanation. As in the past, God will be whittled away even more in the future as these gaps are filled in scientifically. Also, Intelligent Design theory ends up portraying God “as a clumsy Creator, having to intervene at regular intervals to fix the inadequacies of his own initial plan” that supposedly had included trustworthy, consistent natural laws."), _c('a', {
    attrs: {
      "id": "inote-69"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-69",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" In summary, Collins finds Intelligent Design to be simultaneously bad science and bad theology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Evolutionary biologist Richard Dawkins was also on campus in 2008. A year earlier a cover story in "), _c('em', [_vm._v("Time")]), _vm._v(" magazine entitled “God vs. Science”"), _c('a', {
    attrs: {
      "id": "inote-70"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-70",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" featured a debate between Dawkins and Collins. Collins suggests that atheists like Dawkins “sometimes come across as a bit arrogant … characterizing faith as something only an idiot would attach themselves to.”"), _c('a', {
    attrs: {
      "id": "inote-71"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-71",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" Dawkins suggests that Christians like Collins should realize from the discoveries of modern science that “If there is a God, it's going to be a whole lot bigger and a whole lot more incomprehensible than anything that any theologian of any religion has ever proposed.”"), _c('a', {
    attrs: {
      "id": "inote-72"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-72",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One area where the two of them seem to agree, however, is in resisting the attempts of the religious right and the federal government to denigrate or curtail modern science. Both scientists are in favor of opening new stem-cell lines to develop medical cures and save lives. They "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("are both concerned about good science education in our schools, from kindergarten all the way through graduate and medical school. This is an area that the 10,000 signatories of the clergy letter for Evolution Sunday are also deeply concerned about: “We urge school board members to preserve the integrity of the science curriculum by affirming the teaching of the theory of evolution as a core component of human knowledge.”"), _c('a', {
    attrs: {
      "id": "inote-73"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-73",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It's astounding to note that in a 2004 Gallup poll, when asked which of three views on the origin and development of human beings came closest to their own, 45 percent of Americans chose this statement: “God created human beings pretty much in their present form at one time within the last 10,000 years or so.”"), _c('a', {
    attrs: {
      "id": "inote-74"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-74",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("56")])]), _vm._v(" Stanford professor of evolutionary biology Joan Roughgarden in a little book called "), _c('em', [_vm._v("Evolution and Christian Faith,")]), _vm._v(" in which she reconciles science and religion for herself, cites another 2004 poll that found 35 percent of Protestant doctors believe that “God created humans exactly as they appear now.” These are American physicians who have made it all the way through college and medical school and are now practicing medicine! A larger percentage (65 percent) of all physicians approve of teaching biblical creationism alongside evolution in our public schools. Perhaps this wouldn't be utterly worrisome if polls didn't also show that 40 percent of Americans want to replace evolution with creationism in our public school science curriculum."), _c('a', {
    attrs: {
      "id": "inote-75"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-75",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There's too much that really matters in our world to allow conservative religion to trump science education about evolution. Without understanding evolution, medical cures based on the genome project and stem-cell research are impossible. There are implications for our economy as well—will we not train our children to be scientifically competitive in the global marketplace? There are also implications for understanding our environment and ultimately for saving the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It's time now for a reconciliation between science and religion that allows both to flourish and to complement each other. Francis Collins at the end of his book calls for “a truce in the escalating war between science and spirit.” He claims that “Like so many earthly wars, this one has been initiated and intensified by extremists on both sides, sounding alarms that predict imminent ruin unless the other side is vanquished … Abandon the battlements. Our hopes, joys, and the future of our world depend on it.”"), _c('a', {
    attrs: {
      "id": "inote-76"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-76",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("58")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("A CHRISTIAN RATIONALE FOR ABORTION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I preached a sermon after the national elections in 2004 mentioning that exit polls showed 22 percent of Americans nationwide put “moral values” as their top issue. Commentators had explained that, “No doubt about it, abortion and gay marriage were the wedge issues that separated the [Republicans from the Democrats] in the voting booth.”"), _c('a', {
    attrs: {
      "id": "inote-77"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-77",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" Those “moral values” voters went for President George W. Bush by 79 percent, as compared to 18 percent for Senator John Kerry."), _c('a', {
    attrs: {
      "id": "inote-78"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-78",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("60")])]), _c('em', [_vm._v("I")]), _vm._v(" am personally deeply concerned about moral values, and I didn't cast my ballot for Bush in 2004. I affirmed in a post-election sermon that “I'm a professing Christian among many, who on religious grounds, is pro-choice on abortion and in favor of gay marriage.”"), _c('a', {
    attrs: {
      "id": "inote-79"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-79",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the talk-back after the sermon, a Stanford student asked me to explain my statement that I'm pro-choice on abortion on "), _c('em', [_vm._v("religious")]), _vm._v(" grounds. He could understand how I might be pro-choice on "), _c('em', [_vm._v("pragmatic")]), _vm._v(" grounds, or on the basis of a political philosophy that we shouldn't legislate what other people can do in their private sexual lives. But he'd certainly never heard anyone defend a pro-choice position on explicitly "), _c('em', [_vm._v("religious")]), _vm._v(" grounds. He thought the only genuine Christian position was, and ever could be, anti-abortion and therefore anti-choice. I gave him a brief answer in the talk-back, reminding him that most mainline Protestant Christian denominations, along with Reform and Conservative Jews, have issued pro-choice proclamations consistently over the last thirty years. I also admitted that I hadn't preached on this subject in my years at Stanford, and that I should probably say something about it from the pulpit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So in December, in the midst of Advent—when the gospel reading in the lectionary was the Magnificat of Mary,"), _c('a', {
    attrs: {
      "id": "inote-80"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-80",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v(" her hymn of praise to God for the promised birth of Jesus from her very womb—I preached my Christian rationale for abortion. Why in the midst of a period of expectation of the birth of the Christ child in the liturgical calendar would I speak about the religious justification for abortion? Precisely because Mary's position in the Advent story is similar to that of many women who choose to have an abortion and yet so very different. She's young and poor. She faces unexpected pregnancy—not something she has planned for or wants at this time in her life. She isn't married yet. She knows what this might mean to the man she wants to marry, Joseph. He'll realize that this can't be "), _c('em', [_vm._v("his")]), _vm._v(" baby "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("she's carrying because they haven't had sexual relations yet. Even though she's formally engaged to him, this could mean the end of their marriage before it begins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And sure enough, as it's reported in Matthew's gospel, once Joseph found out Mary was pregnant, “being a righteous man and unwilling to expose her to public disgrace, [he] planned to dismiss her quietly.” The account in Matthew continues in this way: “But just when he had resolved to do this, an angel of the Lord appeared to him in a dream and said, ‘Joseph, son of David, do not be afraid to take Mary as your wife, for the child conceived in her is from the Holy Spirit.’”"), _c('a', {
    attrs: {
      "id": "inote-81"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-81",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" So Mary's situation is utterly unique. She is the most blessed among all women."), _c('a', {
    attrs: {
      "id": "inote-82"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-82",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("64")])]), _vm._v(" She is to be favored by becoming the mother of the Son of God."), _c('a', {
    attrs: {
      "id": "inote-83"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-83",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" After she questions the angel Gabriel when he first visits to tell her of her favor with God, and after some soul-searching, Mary makes a voluntary decision, as the Gospel of Luke puts it, to allow the Holy Spirit to come upon her, to have the power of the Most High overshadow her. Mary says: “Here am I, the servant of the Lord; let it be with me according to your word.”"), _c('a', {
    attrs: {
      "id": "inote-84"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-84",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Precisely because Mary's situation is utterly unique, it places in bold relief other girls and women who have "), _c('em', [_vm._v("not")]), _vm._v(" voluntarily chosen to become pregnant. How about an 11- or 12-year-old, or a teenager, who has been continually forced to undergo incest by her father or stepfather? What about a woman who is forcibly raped on her way home from work by someone she never met, or a Stanford student who is date-raped by a fellow student whom she thought she knew rather well but obviously didn't? What about the very young and the very ignorant who may have voluntarily engaged in sexual relations but lacked information about effective contraception because they did not receive sex education at school or at home? What about a mature woman—even one who's happily had other children—whose physical or mental health might be severely compromised by this pregnancy? What about a fetus that has been found through amniocentesis or ultrasound to be severely and irreversibly impaired? Of course, the cases go on and on, including those so often cited by antiabortion activists—those women who are allegedly having “abortions of convenience” (which undeniably does happen).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I want to make it clear that I respect the views of religious people who are opposed to abortion because they truly consider it to be murder or simply to be wrong on other conscientiously considered grounds. There "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("are many of them on the Stanford campus in the Catholic community, evangelical Protestant groups, and other religious organizations. My job as dean for religious life is to be sure that their voices are not squelched or censored and that they can flourish and thrive in religious communities. I personally would join them on this issue if I thought that an embryo or a fetus is fully a human being or a person. I don't think “a woman's right to choose” is a sufficient answer to the claim that “abortion is murder.” If by abortion we're killing human beings or persons, then a woman does not have a right to choose to kill, except in the very limited circumstances of self-defense—where it's a matter of either she dies or the fetus dies (say in an ectopic pregnancy or with certain kinds of cancer).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet, fetus as “person” or “human being” has never been a settled question within Christianity or Judaism. There are large segments of the Judeo-Christian world that, historically and currently, see the embryo or fetus as "), _c('em', [_vm._v("potential")]), _vm._v(" human life, but not as fully human until birth or until some stage in fetal development well past conception. My personal religious understanding is that human life or personhood begins at birth, but I also think there are important protections that should be applied to "), _c('em', [_vm._v("potential")]), _vm._v(" human life at certain stages of fetal development. Let me trace some of that religious history now, especially since the Bible is appealed to by so many anti-abortion Christians. This discussion may seem a bit technical, but I believe the background is important to understand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There's nothing explicitly said in the Bible about induced abortion. Zero. The Jewish position begins with Exodus 21:22: “When people who are fighting injure a pregnant woman so that there is a miscarriage, and yet no further harm follows, the one responsible shall be fined what the woman's husband demands, paying as much as the judges determine.” So, only a fine; no punishment for homicide. On the basis of this passage, the rabbis argued in the Talmud that a fetus is not considered "), _c('em', [_vm._v("adam")]), _vm._v(" (human) and has no legal standing as a person. Killing a fetus is not murder and it is not treated that way."), _c('a', {
    attrs: {
      "id": "inote-85"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-85",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" The mainstream Jewish position historically and today is that human life or personhood begins at birth, when we take our first breath."), _c('a', {
    attrs: {
      "id": "inote-86"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-86",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("68")])]), _vm._v(" There are a number of biblical passages that have been cited by rabbis over the years as connecting the breath and human life, starting with the creation story in Genesis 2:7: “The Lord God formed man from the dust of the ground, and breathed into his nostrils the breath of life; and the man became a living being.”"), _c('a', {
    attrs: {
      "id": "inote-87"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-87",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("This is not to say that Judaism doesn't take the value of potential life in the womb very seriously, before and after the heart starts beating and brain activity begins. Historically, as required in Exodus, there have been fines for killing a fetus, and, in the words of the Conservative rabbinate, “the decision to abort should not be taken lightly.” Most Orthodox rabbis approve abortion only to protect the life or health of the mother. Conservatives sanction abortion under a wider range of circumstances, but always thoughtfully and prayerfully. The Reform rabbinate leaves the decision whether or not to terminate a pregnancy in the hands of a woman or her family, but recognizes how difficult that decision often is."), _c('a', {
    attrs: {
      "id": "inote-88"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-88",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For most of the history of the Catholic Church, one did not become a human being or a person until well after conception. Saint Augustine in the fourth century adopted the Aristotelian belief that the human soul didn't enter the fetus until 40 to 90 days after conception. In roughly the same era Saint Jerome emphasized human shape: “The seed gradually takes shape in the uterus, and it [abortion] does not count as killing until the individual elements have acquired their external appearance and their limbs.”"), _c('a', {
    attrs: {
      "id": "inote-89"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-89",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v(" The Apostolic Constitutions of the late fourth century allowed abortion if it was done both before the human soul entered and before the fetus was of human shape. St. Thomas Aquinas of the thirteenth century followed Augustine in not considering the abortion of a non-ensouled fetus to be murder. Pope Innocent III earlier in the same century as Aquinas emphasized that the soul enters the body at the time of quickening—when a prospective mother first feels movement of the fetus. When Pope Gregory XIV affirmed the quickening test for ensoulment in 1591, he set the time for it as 116 days into pregnancy, or the sixteenth week. The great reversal came with Pope Pius IX in 1869. He assumed ensoulment at conception and by 1917 church canon law had been revised, dropping the prior distinction it had upheld between “animated” and “inanimated” fetuses. Pius's position has been maintained by the Catholic Church ever since."), _c('a', {
    attrs: {
      "id": "inote-90"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-90",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Likewise, criminal abortion statutes generally didn't come into effect in the United States until the latter part of the nineteenth century. The common law had long held that an abortion performed prior to quickening was not an indictable offense. Even abortion of a quickened fetus was generally not considered a criminal act under the common law, or at most a mere misdemeanor."), _c('a', {
    attrs: {
      "id": "inote-91"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-91",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("73")])]), _vm._v(" The U.S. Supreme Court in its 1973 "), _c('em', [_vm._v("Roe v. Wade")]), _vm._v(" decision used religious references to explain, in part, why the word "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("“person” as used in the U.S. Constitution does not include the unborn: “There has always been strong support for the view that [human] life does not begin until live birth. This was the belief of the Stoics. It appears to be the predominant … attitude of the Jewish faith. It may be taken to represent … a large segment of the Protestant community.”"), _c('a', {
    attrs: {
      "id": "inote-92"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-92",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I'm personally part of that large Protestant community that believes that human life and personhood begin at birth. Some of my feelings admittedly may stem from the connotations of the words “birth” and “conception” with which I have grown up within the church. We speak of Esau and others in the Bible having a birthright, not a conception-right. After a strong religious experience we might say we've been “born again,” but not “conceived again.” Various biblical characters speak of the land of their "), _c('em', [_vm._v("birth.")]), _vm._v(" We honor the "), _c('em', [_vm._v("birth")]), _vm._v(" of the nation of Israel. We celebrate birthdays, including Christmas as the birth of Christ. I have done a concordance check of the Bible and found 216 references to “birth” or “born” and only 43 to “conception” or “conceive,” a 5-to-1 ratio. The majority of the uses of “conceived” were linked to being born in this way: “she conceived and bore a child.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I'm also personally compelled by the notion that it's the breath of life that makes us full human beings. I'll never forget the sight of each of my children emerging into the world blue and lifeless, being struck on the back by the doctor, taking their first breath, and becoming ruddy-colored as they began crying their way into life. "), _c('em', [_vm._v("Now")]), _vm._v(" they were tiny people. "), _c('em', [_vm._v("Now")]), _vm._v(" they had joined the human race, not before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other hand, it seems religiously important to me to be very concerned about potential life, not just actual life. Christians celebrate Advent as a time of waiting in the darkness for the light that will come at Christmas. The nine months of pregnancy for an expectant mother is a very important time of preparation for the baby-to-come and, ideally, of careful monitoring of maternal and prenatal health. Fetal life is a magnificent continuum of development from the zygote at the time of conception, to the manifestation of the embryo at about fourteen days, to the formation of what we call the fetus at about three months. Of course, for those first two weeks it's not at all clear that the zygote will become a singular embryo, much less a human being. Two-thirds of the time, the zygote doesn't develop into anything at all. Sometimes it develops into a tumor. Or it could become an embryo or more than one if it splits into twins."), _c('a', {
    attrs: {
      "id": "inote-93"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-93",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" Once it's an embryo, it'll be a long time—another "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("22 weeks or so—before it reaches viability or the stage of development when it might survive outside the womb.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is where I personally think the Supreme Court got it right in 1973 in terms of protection of potential life. During the first trimester—when abortion could occur with an IUD, a morning-after-pill, RU486, or minor surgical procedures—the decision to abort is entirely the woman's. In the second trimester, with quickening, human shaping, and the necessity of more complicated surgical procedures, the state has a right to regulate medical procedures to protect the health of the mother. (In fact, less than 10 percent of abortions now take place after the first trimester.)"), _c('a', {
    attrs: {
      "id": "inote-94"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-94",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" By the third trimester, though, the potential life has become viable; since the fetus could now live outside the womb, the state has a right to protect that potential life by prohibiting abortion except to preserve the life or health of the mother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite all of this discussion, I want to emphasize that I and many other religious people of all persuasions would like greatly to reduce the incidence of abortion. As the Lutheran Women's Caucus resolved in 1990, abortion should not be the stopgap for lack of contraception, for inadequate sex education, or for irresponsible sexuality—not to mention being resorted to because of insufficient social support for new human life, such as lack of health care, child care, or parental leave. I join in the call of the Lutheran Women's Caucus to work actively for social and cultural changes that will reduce the incidence of abortion and also stop the scapegoating of women who have abortions."), _c('a', {
    attrs: {
      "id": "inote-95"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-95",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" Nonetheless, there are strong religious grounds, historical and contemporary, to defend a woman's right to an abortion.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("THE SANCTIFICATION OF MARRIAGES FOR SAME-SEX COUPLES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have been deeply moved by the decisions of the supreme courts of California, Connecticut, and Massachusetts to affirm the rights of samesex couples to marry. It's about time, religiously as well as politically. There's a true story from an earlier time that makes this particularly poignant for me. It's the story of Davis and Perez, who fell in love and tried to "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("get married, only to be turned away by a county clerk who refused to issue them a marriage license simply because of who they were as a condition of their birth. A courageous state court in California became the first in the nation, albeit by a very close 4 to 3 majority, to find that clerk's refusal unconstitutional. And that decision was made after more than 30 state legislatures had put laws on the books that said no such marriage would be recognized in their states.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Marriage is something more than a civil contract, subject to regulation by the state. It is a fundamental right…” Those are the words of the California court. As the United States Supreme Court has also long held, marriage is one of the “basic civil rights of man.”"), _c('a', {
    attrs: {
      "id": "inote-96"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-96",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" From a religious perspective, marriage of course has long been held to be sacred, and it's often noted that, in the Gospel of John, Jesus's very first miracle was performed at a wedding at Cana of Galilee."), _c('a', {
    attrs: {
      "id": "inote-97"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-97",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" The California court made it clear that “there can be no prohibition of marriage except for an important social objective and by reasonable means.” Moreover, that “Legislation infringing … [the fundamental right to marry] must be based on more than prejudice and must be free from oppressive discrimination to comply with the constitutional requirements of due process and equal protection of the law.” The court then went on to consider and reject claims that the unions under consideration were unnatural and that they were not the ideal context within which to raise children. To the claim that children within such unions would experience stigma and suffer societally, the court responded: “If they do, the fault lies not with their parents, but with the prejudices in the community and the laws that perpetuate those prejudices by giving [them] legal forc e … ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The three-judge dissent argued that who should marry is a matter for legislatures, not for courts to decide “in order that the well being of society as a whole may be safeguarded or promoted.” The dissenters stated, “It is not within the province of the courts to go behind the findings of the legislature,” which “in the first instance” should decide “what is necessary for the public welfare. Earnest conflict of opinion makes it especially a question for the legislature and not for the courts.” Bolstering their case, the dissenting judges also noted that laws prohibiting these unions “have been in effect since before our national independence and in this state since our first legislative session.” The majority opinion, however, "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("retorted that “certainly the fact alone that the discrimination has been sanctioned by the state for many years does not supply … justification.” The majority made it clear that when it comes to constitutional law, statutes duly enacted by state legislatures or the U.S. Congress must be struck down if they fail to meet judicial standards of due process or equal protection of the law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so, in 1948, the year I was born, the California Supreme Court became the first in the nation to strike down an antimiscegenation law at a time when marriages between blacks and whites could not be performed in a majority of these United States."), _c('a', {
    attrs: {
      "id": "inote-98"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-98",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" The "), _c('em', [_vm._v("Nation")]), _vm._v(" magazine, touting itself as “America's Leading Liberal Weekly Since 1865,” commended the religious organization that had represented Sylvester Davis, a Negro, and Andrea Perez, his white fiancée. As the "), _c('em', [_vm._v("Nation")]), _vm._v(" explained, at that time “Most of the civil rights organizations failed or refused to participate in the case on the assumption that miscegenation statutes could not be successfully challenged in the courts.”"), _c('a', {
    attrs: {
      "id": "inote-99"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-99",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It took almost another 20 years until the United States Supreme Court spoke on this subject in a 1967 case coincidentally named "), _c('em', [_vm._v("Loving v. Virginia.")]), _c('a', {
    attrs: {
      "id": "inote-100"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-100",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("82")])]), _vm._v(" By that time I was in college, and we were within a year of the end of Martin Luther King's life, but more than half of the states with antimiscegenation laws in 1948 would still not permit a black person to marry a white person. The state of Virginia had argued that there was a rational basis to treat interracial unions differently from same-race unions and to refuse them marital status. They argued that, at minimum, the scientific evidence about black-white differences and their implications was still in doubt. Virginia claimed that the courts should stay out of these matters, and instead, they should defer to the democratic wisdom of legislatures in the matter of who should be allowed to marry or not, and why. The U.S. Supreme Court responded that it had the duty to decide whether laws passed muster under the due process and equal protection clauses of the Constitution. It then explained that under our Constitution the freedom to decide whom to marry is a fundamental right that resides with the individual and cannot be infringed upon by any state legislature without compelling justification.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Religion had a central role to play in the public debate about black-white marriage. It explicitly worked its way into the "), _c('em', [_vm._v("Loving v. Virginia")]), _vm._v(" decision. When Richard Loving and Mildred Jeter were convicted of violating Virginia's ban on interracial marriages by establishing their marital "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("abode in the state after having been lawfully married in the District of Columbia, the state trial court judge wrote in his opinion: “Almighty God created the races white, black, yellow, malay, and red, and he placed them on separate continents. And but for the interference with his arrangement, there would be no cause for such marriages. The fact that he separated the races shows that he did not intend for the races to mix.”"), _c('a', {
    attrs: {
      "id": "inote-101"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-101",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the 1948 California decision, it was the Catholic Church, however, through its Interracial Council in Los Angeles, that made a religious argument on behalf of the partners in the case, both of whom were Catholic."), _c('a', {
    attrs: {
      "id": "inote-102"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-102",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("84")])]), _vm._v(" The claim was that Davis and Perez were being denied their right to participate fully in the sacraments of their church by being denied the right to marry. One of the concurring judges cited the Bible as a positive authority on intermarriage, using these words: “The Apostle Paul declared that ‘God … hath made of one blood all nations of men for to dwell on all the face of the earth.’ ”"), _c('a', {
    attrs: {
      "id": "inote-103"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-103",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("85")])]), _vm._v(" Ironically, this was probably the same biblical passage that the Virginia judge used in denying people the right to marry because of the color of their skin. For the apostle Paul's words continue by stating that along with God making of one blood all nations of men, God also “hath … determined the bounds of their habitation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What can we learn from this chapter in American history for our nation's current debate about the boundaries of the fundamental, sacred right to marry? In particular, what does the Bible teach us about how to approach this question as religious people, especially when very different conclusions seem to be drawn from the same Bible passage?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First of all, it should be noted that there are only a few references to homosexuality in the Bible, compared to a huge corpus, for example, that assumes and defends slavery. The abolitionists had much more of an uphill battle eliminating slavery in the face of its biblical defenders than the proponents of marriage equality for homosexuals should have in eliminating this form of discrimination. Jesus never references homosexuality. It's not found in the Ten Commandments as adultery and covetousness are. The Old Testament Sodom and Gomorrah story refers not to consensual sex but to homosexual rape."), _c('a', {
    attrs: {
      "id": "inote-104"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-104",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("86")])]), _vm._v(" The two references in Leviticus"), _c('a', {
    attrs: {
      "id": "inote-105"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-105",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("87")])]), _vm._v(" are in the context of setting Jews apart from their Gentile neighbors by avoiding so-called ritual impurities like eating pork, having tattoos, wearing clothes made of two different kinds of materials, and having sex when a woman is menstruating."), _c('a', {
    attrs: {
      "id": "inote-106"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-106",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("88")])]), _vm._v(" In the New Testament, homosexuality is referred to in "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("three letters of the apostle Paul,"), _c('a', {
    attrs: {
      "id": "inote-107"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-107",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("89")])]), _vm._v(" in which it's likely that he was referring to pagan practices of prostitution and sex with children."), _c('a', {
    attrs: {
      "id": "inote-108"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-108",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("90")])]), _vm._v(" In none of these cases was anything vaguely contemplated along the lines of a lifelong monogamous commitment between same-sex partners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Secondly, it should be remembered that Jesus went out of his way to bless those who are hated, excluded, reviled, and defamed. He also blessed those who weep, who are hungry, who are impoverished."), _c('a', {
    attrs: {
      "id": "inote-109"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-109",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("91")])]), _vm._v(" It seems to me that there are two central messages that Jesus tries to convey again and again throughout the New Testament: first, a message of deep concern for those who are oppressed, and, second, a message of profound love that passes all understanding. The scandal of Jesus's ministry in its time, and today as well, is that he constantly stood with the outcast, those who were discriminated against, and those who suffered at the hands of the established principalities and powers of his day."), _c('a', {
    attrs: {
      "id": "inote-110"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-110",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("92")])]), _vm._v(" Upon the oppressed he pronounced God's blessing. Jesus also brought a lesson of love that turned the world on its ear. He went beyond the love represented between husband and wife at Cana of Galilee to ask us to love our neighbors as ourselves,"), _c('a', {
    attrs: {
      "id": "inote-111"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-111",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("93")])]), _vm._v(" and then beyond that to ask us to love even our enemies."), _c('a', {
    attrs: {
      "id": "inote-112"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-112",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("94")])]), _vm._v(" The apostle Paul explains in a passage often read in marriage ceremonies that “If I speak in the tongues of mortals and of angels, but do not have love, I am a noisy gong or a clang i ng cy mbal … Love is patient; love is kind … It doe s not i nsist on its own way; it is not irritable or resentful; … It endures all things.”"), _c('a', {
    attrs: {
      "id": "inote-113"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-113",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("None of this helps us specifically to know what Jesus and his disciples would say about marriages between blacks and whites, and it's possible to find a proof text in the Bible for virtually any claim, but for me it's clear. Instead of the judge's proof-texting—“the fact that he [Almighty God] separated the races shows that he did not intend for the races to mix”—the New Testament record as a whole leads me to believe that Jesus had a generous view of lifelong, committed, monogamous, loving relationships between any two people who freely choose each other to marry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jesus also speaks of prophets and false prophets."), _c('a', {
    attrs: {
      "id": "inote-114"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-114",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("96")])]), _vm._v(" How can you or I know which tradition we're in? Jesus explains that often true prophets run against the social consensus, being hated, excluded, reviled, and defamed, while false prophets run with the crowd, with all speaking well of them. The 1948 California decision that allowed blacks to marry whites was so far outside of the social consensus that not even major civil rights organizations were willing to sign onto the court challenge. It was a closely divided "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("4–3 decision within the court, with the attorney for the county of Los Angeles arguing, “The amalgamation of the races is not only unnatural, but always productive of deplorable results.”"), _c('a', {
    attrs: {
      "id": "inote-115"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-115",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("97")])]), _vm._v(" Some twenty years later, though, a unanimous United States Supreme Court would strike down the remaining antimiscegenation laws across the country in a brief opinion, stating that the only basis for such racial classification could be to maintain white supremacy. Social consensus can shift dramatically in one generation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other side of the question of social consensus lie those individuals who are deeply hurt and harmed by claims that they are inferior or sinful, that their marriage would be unnatural and productive of deplorable results. How horrible for them. Again, it seems to me that these are precisely the kinds of people whom Jesus always comforted and sanctified first: “Blessed are you who weep now, for you will laugh.”"), _c('a', {
    attrs: {
      "id": "inote-116"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-116",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("98")])]), _vm._v(" I read the New Testament record as a whole as placing a very generous conception of love at the very center of Jesus's teaching and actions. These are the criteria—standing with the oppressed and a generous conception of love—on which I believe we should try to distinguish true prophets from false prophets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet, Jesus also manifested a kind of humility that we would all do well to remember. He said, “Do not judge and you will not be judged; do not condemn, and you will not be condemned.”"), _c('a', {
    attrs: {
      "id": "inote-117"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-117",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("99")])]), _vm._v(" In a panel discussion at Stanford during which I advocated for marriage between same-sex couples, an audience member asked me how I respond to the claim that such marriages undermine or harm traditional institutions. I responded by saying that “The harm that is done to someone when you say they can't marry the person of their choice is unconscionable.”"), _c('a', {
    attrs: {
      "id": "inote-118"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-118",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("100")])]), _vm._v(" Afterward I apologized for the use of the word “unconscionable” to my colleague on the panel from the Campus Crusade for Christ, who is opposed to same-sex marriages and thinks they might undermine the structure of the traditional family."), _c('a', {
    attrs: {
      "id": "inote-119"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-119",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("101")])]), _vm._v(" I know him well personally and respect how conscientiously he thinks about and struggles with this question. And, according to all the polls I read, the majority of Americans, religious and secular, agree with him and not with me. I need to have enough humility of the sort Jesus called for to state my own beliefs clearly and act upon them, while at the same time understanding and respecting how people of conscience can differ on important questions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("By way of conclusion, though, on the issue of conscience, I must say that I'm haunted by the fact that it took the largest Protestant denomination in the United States, the Southern Baptists (the religious tradition of two recent American presidents, Jimmy Carter and Bill Clinton), until 1995 to apologize for the role it played in the biblical justification of slavery in the nineteenth century and in the maintenance of a culture of racism in the twentieth century. In their efforts, the denomination had used biblical proof texts like the words of Paul I've cited or this one from the Letter to the Ephesians: “Slaves, obey your earthly masters with fear and trembling, in singleness of heart, as you obey Christ.”"), _c('a', {
    attrs: {
      "id": "inote-120"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-120",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("102")])]), _vm._v(" The social historian C. Eric Lincoln wrote in 1995, after the church's historic apology: “Just think of all the violence and bitterness we might have been spared if the Southern Baptists had repudiated racism earlier.”"), _c('a', {
    attrs: {
      "id": "inote-121"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-121",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("103")])]), _vm._v(" To that I can only say Amen.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee79eafe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780230240582_09_chap01.vue
// module id = 81
// module chunks = 0